import Alpine from "alpinejs";

Alpine.magic("storage", () => {
    return {
        set(key, value, type="localStorage") {
            if (type == "sessionStorage") {
                return window.sessionStorage.setItem(key, value);
            }
            return window.localStorage.setItem(key, value);
        },
        get(key, type="localStorage") {
            if (type == "sessionStorage") {
                return window.sessionStorage.getItem(key);
            }
            return window.localStorage.getItem(key);
        },
        removeItem(key, type="localStorage") {
            if (type == "sessionStorage") {
                return window.sessionStorage.removeItem(key);
            }
            return window.localStorage.removeItem(key);
        }
    };
});